import React from "react";
import { BadgeWithIconProps } from "../../../../data-model/badgeWithIconProps";
import BadgeDropdown from "../../../badgeDropdown/badgeDropdown";

export interface BadgeSelectCellValue {
  selectedBadge: BadgeWithIconProps | null;
  badgeList: BadgeWithIconProps[];
}

interface BadgeSelectCellProps {
  value: BadgeSelectCellValue;
  rowData?: any;
  header?: string;
  onCellValueChange?: (rowData: any, fieldKey: string, newValue: any) => void;
}

const BadgeSelectCell: React.FC<BadgeSelectCellProps> = ({
  value,
  rowData,
  header,
  onCellValueChange,
}) => {
  const handleBadgeClick = (badgeId: string) => {
    if (badgeId !== value.selectedBadge?.id && onCellValueChange) {
      onCellValueChange(rowData, header || "", badgeId);
    }
  };

  return (
    <BadgeDropdown
      selectedBadge={value.selectedBadge}
      badgeList={value.badgeList}
      onClick={handleBadgeClick}
      shouldUsePortal
    />
  );
};

export default BadgeSelectCell;
